import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SupplierScreen from '../../screens/Supplier/SupplierScreen';
import { loadSuppliers } from '../../core/utils/supplier';

const SuppliersContainer = ({}) => {
  const [data, setData] = useState([]);
  const reloadSupplier = useSelector((state) => state.app.reloadSupplier || false);
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  useEffect(() => {
    loadData();
  }, [reloadSupplier, company]);

  const loadData = async () => {
    if (!company.id) return;
    const suppliers = await loadSuppliers(company.id);
    setData(
      (suppliers || []).map((item) => ({
        ...item,
        created_at: dayjs(item.created_at).format('DD/MM/YYYY'),
      }))
    );
  };

  return <SupplierScreen data={data} company={company} user={user} />;
};

export default SuppliersContainer;
